'use client';
import { lazy, Suspense, type ComponentProps } from 'react';
export type * from "/tmp/build-301/node_modules/@eliadmin/core/src/pages/(profile)/orders/page.tsx";
type Props = NonNullable<ComponentProps<typeof import("/tmp/build-301/node_modules/@eliadmin/core/src/pages/(profile)/orders/page.tsx").default>>;
const Deferred = lazy(() => import("@eliadmin/route-original/54bb1f52ef48"));
function DeferredRoute(props: Props) { return <Suspense fallback={null}><Deferred {...props} /></Suspense>; }
export default DeferredRoute;

